import React, { useState, useEffect } from "react";
import Data from "../App";
import { map, distinctUntilChanged } from "rxjs/operators";

const UiBindingPreview = ({ binding }) => {
  return (
    <div className="BindingPreviewRow">
      <div className="BindingAttribute">{binding.get("attribute")}</div>
      <div className="BindingCasesPreview">
        <span>
          {binding.get("cases").map((aCase, index) => {
            return (index > 0 ? "," : "") + aCase.get("case_value");
          })}
        </span>
      </div>
    </div>
  );
};
export default UiBindingPreview;



// WEBPACK FOOTER //
// ./src/components/UiBindingPreview.js